module.exports = __webpack_public_path__ + "static/media/cvc.c797306b.svg";